import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import { fetchFlows } from 'Actions/bots'
import { getDefaultFlowId } from 'Src/reselect/bots'

const FlowLoader = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { botId } = useParams()
  const defaultFlowId = useSelector((state) => getDefaultFlowId(state, botId))

  useEffect(() => {
    if (defaultFlowId) {
      navigate(`flows/${defaultFlowId}`, { replace: true })
    }
  }, [defaultFlowId, botId, navigate])

  useEffect(() => {
    dispatch(fetchFlows(botId))
  }, [dispatch, botId])

  return (
    <div style={{ display: 'grid', height: '80vh', width: '100%' }}>
      <span style={{ margin: 'auto' }}>Loading Flow...</span>
    </div>
  )
}

export default FlowLoader
